import { Navigate } from 'react-router-dom';

import AuthGuard from '@/components/Auth/AuthGuard';
import {
  LoggedType,
  useUserAuthContext,
} from '@/components/AuthTokenContextProvider/UserAuthContext';

export default function AdminRoute({ children }: { children: JSX.Element }) {
  const authContext = useUserAuthContext();

  return (
    <AuthGuard>
      {authContext.status === LoggedType.LOGGED_IN && authContext.isAdmin ? (
        children
      ) : (
        <Navigate replace to="/" />
      )}
    </AuthGuard>
  );
}
